'use strict';

let logCollectorURL = null;
const http = require('./http');
const severityMapper = require('./severityMapper');
const logBatches = {};
const logBatchSize = 50;
let syncTimeout = null;
let logLabels = {};

function makeBatchID() {
  let id = Math.floor(new Date().getTime() / 1000) + '_';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < 24; i++) {
    id += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return id;
}

function fixDayMonthDigits(number) {
  return number.toString().length === 2 ?
    number : '0' + number;
}

function generateLogTimestamp() {
  const currentDate = new Date();
  return currentDate.getUTCFullYear() + '-'
    + fixDayMonthDigits(currentDate.getUTCMonth() + 1) + '-'
    + fixDayMonthDigits(currentDate.getUTCDate()) + 'T'
    + fixDayMonthDigits(currentDate.getUTCHours()) + ':'
    + fixDayMonthDigits(currentDate.getUTCMinutes()) + ':'
    + fixDayMonthDigits(currentDate.getUTCSeconds()) + 'Z'
}

function updateCommonLabels() {
  try {
    logLabels['url'] = window.location.href;
  } catch (e) {
  }
}

function buildLog(stackDriverData, severity, logArguments) {
  const logName = stackDriverData.logName;

  const logData = [];
  for (let i = 0; i < logArguments.length; i++) {
    const argValue = logArguments[i];
    if (typeof argValue === 'string') {
      logData.push(argValue);
      continue;
    }
    try {
      logData.push(JSON.stringify(argValue));
    } catch (e) {}
  }

  updateCommonLabels();

  return {
    logName: logName,
    resource: {
      type: stackDriverData.resourceType,
    },
    timestamp: generateLogTimestamp(),
    severity: severityMapper.toStackDriverNumericLevel(severity),
    labels: logLabels,
    textPayload: logData.join(' '),
  }
}

function buildSendLogsRequest(logEntries) {
  return {
    "entries": logEntries
  }
}

function getAvailableBatch() {
  for (const batchUUID in logBatches) {
    if (!logBatches[batchUUID].locked && logBatches[batchUUID].entries.length < logBatchSize) {
      return logBatches[batchUUID];
    }
  }
  const newBatchId = makeBatchID();
  logBatches[newBatchId] = {entries: [], locked: false};
  return logBatches[newBatchId];
}

function syncBatches(apiKey, flushAll) {
  for (const batchUUID in logBatches) {
    if (logBatches[batchUUID].locked) {
      continue;
    }
    if (flushAll || logBatches[batchUUID].entries.length === logBatchSize) {
      logBatches[batchUUID].locked = true;
      sendBatch(apiKey, logBatches[batchUUID]).then((response) => {
        console.internal(`Batch ${batchUUID} synchronized with response: `, response);
        delete logBatches[batchUUID];
      }).catch(err => {
        console.internal(`Failed to sync batch ${batchUUID}`, err);
      })
    }
  }
}

async function sendBatch(apiKey, batch) {
  if (batch.entries.length === 0) {
    return;
  }
  const requestData = buildSendLogsRequest(batch.entries);
  return http.sendPostRequest(
    logCollectorURL,
    {'Content-Type': 'application/json', 'Authorization': apiKey},
    requestData
  )
}


module.exports = (options) => {
  const stackDriverOptsForLog = {
    logName: options.logName,
    resourceType: options.resourceType || 'global',
  }

  logLabels = options.logLabels || logLabels;
  logCollectorURL = options.logCollectorURL || logCollectorURL;

  try {
    window.addEventListener("beforeunload", function () {
      syncBatches(options.apiKey, true);
    });
  } catch (e) {

  }

  return {
    pushLog: async function (severity, args) {
      const log = buildLog(stackDriverOptsForLog, severity, args);

      getAvailableBatch().entries.push(log); //Add log entry

      syncBatches(options.apiKey) // Request batch sync

      // Postpone a batch sync in 5 seconds for the case no more logs are pushed and we still have logs to sync
      clearTimeout(syncTimeout);
      syncTimeout = setTimeout(function () {
        syncBatches(options.apiKey, true);
      }, 5000);
    },
    setLogLabel: function (key, value) {
      logLabels[key] = value;
    },
    removeLogLabel: function (key) {
      if (logLabels[key]) {
        delete logLabels[key];
      }
    }
  }
};


